<template>
  <div class="mc-widget-call-broadcast__empty-error-state-wrapper">
    <div class="mc-widget-call-broadcast__empty-error-state-img-wrapper">
      <img src="@/assets/images/alert-report-danger.png" />
    </div>
    <div class="mc-widget-call-broadcast__empty-error-state-content">
      <h3>{{ $t('trackVideo.broadcast.errorStateTitle') }}</h3>
      <p>{{ $t('trackVideo.broadcast.errorStateDesc') }}</p>
    </div>
    <div class="mc-widget-call-broadcast__button-action-wrapper">
      <McButton
        :text="$t('global.action.tryAgain')"
        icon="icon-fill_sync"
        @click="$emit('reconnect')"
      />
      <McButton :text="$t('global.action.close')" variant="outline" @click="$emit('endCall')" />
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
export default {
  name: 'ErrorStateBroadcast',
  components: { McButton },
}
</script>
